import { Select, IProps as SelectProps } from 'components/atoms/Select/Select.components';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

interface ChapterSelectProps extends Omit<SelectProps, 'handleChange'> {
  handleChange: (value: { value: string; externalCode: string }) => void;
  chapter: { name: string; externalCode: string }[];
  isLoading: boolean;
}

export default function ChapterSelect({ idPosition, chapter, isLoading, handleChange, ...rest }: Readonly<ChapterSelectProps>) {

  const { setValue, getValues } = useFormContext();

  const options = chapter?.map(({ name }) => ({
    value: name,
    label: name,
  }));

  useEffect(() => {
    const currentValue = getValues(`growInformation.${idPosition}.chapter`);
    if (chapter && currentValue) {
      const selectedChapter = chapter.find(({ name }) => name === currentValue);
      if (selectedChapter) {
        setValue(`growInformation.${idPosition}.idChapterSap`, selectedChapter.externalCode);
        setValue(`growInformation.${idPosition}.chapter`, currentValue);
      } else {
        setValue(`growInformation.${idPosition}.idChapterSap`, undefined);
        setValue(`growInformation.${idPosition}.chapter`, undefined);
      }
    }
  }, [chapter, getValues, setValue]);

  return (
    <Select
      handleChange={(value) =>
        handleChange({
          value: value?.toString() ?? '',
          externalCode: chapter?.find(({ name }) => name === value)?.externalCode ?? ''
        })
      }
      disabled={isLoading}
      options={options}
      {...rest}
    />
  );
}
